import { DemographicAnalyticsPayload } from '@mm/state/interfaces/botAnalytics';
import { Tooltip } from 'antd';
import classNames from 'classnames';

import React, { ReactNode } from 'react';
import { calcPercentage } from '../../XRayAnalytics/XRayContactsByLandingPage/XRayContactsByLandingPage';
import styles from './DemographicBarChart.module.css';

type Props = {
  icon: ReactNode;
  title: string;

  data: DemographicAnalyticsPayload;
};

export const DemographicBarChart = ({ icon, title, data }: Props) => {
  const { total, records, hits } = data || {};
  const otherIndex = records.findIndex(label => label === 'other');
  const onlyOtherData = Boolean(records.length === 1 && otherIndex !== -1);

  if (onlyOtherData) {
    return <></>;
  }

  return (
    <Tooltip
      title="Data will only be presented on contacts that have demographics data"
      placement="bottom"
      color="#595959"
    >
      <div className={styles.container}>
        <div className={styles.heading}>
          {icon}
          {title}
        </div>

        {records?.map((label, index) => {
          const isOther = label === 'other';

          const percentage = calcPercentage(total || 0, hits?.[index] || 0);

          return (
            <div key={label} className={styles.row}>
              <div className={styles.statsBarRow}>
                <div
                  className={classNames(styles.statsBar, {
                    [styles.otherStatsBar]: isOther,
                  })}
                  style={{ width: !isOther ? `${percentage}%` : '10px' }}
                />
                <span>{label}</span>
              </div>
              {percentage && (
                <div className={styles.numbersRow}>
                  <span className={styles.percentage}>{percentage}%</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Tooltip>
  );
};
